import { Component, OnInit } from '@angular/core';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import * as backInter from 'app/auth/auth-data.model';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from '@fuse/animations';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';


@Component({
  selector: 'adminpulsecheck',
  templateUrl: './admin-pulsecheck.component.html',
  styleUrls: ['./admin-pulsecheck.component.scss'],
  animations : fuseAnimations
})
export class AdminPulsecheckComponent implements OnInit {
  idEmpresa : string;
  productosContratadosInter : backInter.infoProductos;
  aniosPulsecheck:any[]=[];
  noce:any[]=[];
  anioseleccionado:any;
  idiomaActual:string;
  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERRORDATE',
    'SHEDULE.SAMEDATE'
  ];

  mensajesTraducirTS = {
    error1: '',
    error2: ''
  };
btnPortalConteos:boolean= false;
pulse3Navigation:boolean;
linkCertificar3:boolean=false;
productoFocus:boolean;
urlReqtec:string;
  constructor(
    private odsService: ODSService,
    private activatedRoute:ActivatedRoute,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService,
    private snackBar: MatSnackBar,
  ) {
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_focus.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    }

  ngOnInit() {
    console.log(localStorage.getItem('fechaProducto'));
    console.log(localStorage.getItem('tipoProductoRequerimientos'));

    this.getProductsByCompany();
    this.traduceTextosTS();
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        //console.log(k);
        this.mensajesTraducirTS[k] = res;
        // console.log(this.mensajesTraducirTS[k]);
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;


  }




private getProductsByCompany() {

    this.wizardService.getProductos().subscribe((respuesta:backInter.infoProductos) => {
      console.log("Dude");
      console.log(respuesta);
      this.productosContratadosInter = respuesta;
      this.anioseleccionado= localStorage.getItem('fechaProducto');
      console.log(this.anioseleccionado);

      if(this.productosContratadosInter){
switch (localStorage.getItem('tipoProductoRequerimientos')) {
  case '3':
  this.pulseCheckAños();
  this.pulse3Navigation=false;
  this.productoFocus=false;
    break;
  case 'p1':
  this.pulseCheckAños3();
  this.pulse3Navigation=true;
  this.linkCertificar3=true;
  this.productoFocus=false;
  this.urlReqtec= '/requerimentsLandingPulse_t1/adminpulsecheck/requirements-details';
    break;
  case 'f1':
  this.focusAreaAños3();
  this.pulse3Navigation=true;
  this.linkCertificar3=true;
  this.productoFocus=true;
  this.urlReqtec= '/requerimentsLandingfocus/adminfocusarea/requirements-details'
    break;

  default:
    break;
}

      }
    }, error => {
      console.log("error", error);
    })
  }

  private navigateTo(ruta,productoID,idProductoRT?,surveySubDomain?,ipPublic?){
    console.log('productoID',productoID);
    console.log('idProductoRT',idProductoRT);

    localStorage.setItem('productoID', productoID);
    localStorage.setItem('productoIDRequerimientos', productoID);
    localStorage.setItem('idProductoRT', idProductoRT);
    localStorage.setItem('surveySubDomain', surveySubDomain);
    localStorage.setItem('ipPublicSubDomain', ipPublic);
      this.router.navigate([ruta]);
  }
  //
      pulseCheckAños(){
    let moment = require('moment');
    let fechaActualC = moment().format('YYYY/MM/DD');
      let fechaActual:number;
      let fechaPulse:any[]=[];
      this.productosContratadosInter.productosPulseCheck.sort( (a,b) => {
        if(a.fechaPulseCheck > b.fechaPulseCheck){
          return 1;
        } else{
          return -1;
        }
      });
      console.log(this.productosContratadosInter.productosPulseCheck);

      this.productosContratadosInter.productosPulseCheck.forEach((element,i) => {
        let datosPulsechek:any={};
        console.log(element.completoPulseCheck);

        let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
        let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));

        if(fechaPortal){
          console.log("econtro 1");
        this.btnPortalConteos=true;
      }else{
        this.btnPortalConteos=false;
      }
        if(fechaActual){
         datosPulsechek={
           completoPulseCheck: element.completoPulseCheck,
           fechaLanzamiento: element.fechaLanzamiento,
           fechaPulseCheck: element.fechaPulseCheck,
           idPlantilla: element.idPlantilla,
           idPulseCheck: element.idPulseCheck,
           idSurvey: element.idSurvey,
           tokenConfig: element.tokenConfig,
           btnPortalConteos:this.btnPortalConteos,
         }

          console.log(datosPulsechek);

          if(element.fechaPulseCheck == fechaActual){
            fechaPulse.push(element);
            // fechaPulse.push(datosPulsechek);
          }
          else {
            this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
            fechaPulse=[];
            fechaActual=element.fechaPulseCheck;
            fechaPulse.push(element);
            // fechaPulse.push(datosPulsechek);
          }
        }
        else{
          fechaActual=element.fechaPulseCheck;
          fechaPulse.push(element);
          // fechaPulse.push(datosPulsechek);
        }
        fechaPulse.sort( (a,b) => {
          if(a.numero > b.numero){ return 1; } else{ return -1; }
        });
        if(this.productosContratadosInter.productosPulseCheck.length ==(i+1)){
          this.aniosPulsecheck.push({fecha: element.fechaPulseCheck, datos: fechaPulse});
        }
      });
      console.log(this.aniosPulsecheck);
    }


      pulseCheckAños3(){
      let moment = require('moment');
      let fechaActualC = moment().format('YYYY/MM/DD');
        let fechaActual:number;
        let fechaPulse:any[]=[];
        let pulseV3:any[]=[];
    this.productosContratadosInter.productosCertificar.forEach((element) => {
    if (element.idProducto==42) {
    pulseV3.push(element);
    }
    });

        pulseV3.sort( (a,b) => {
          if(a.fechaCertificar > b.fechaCertificar){
            return 1;
          } else{
            return -1;
          }
        });
        console.log(pulseV3);

        pulseV3.forEach((element,i) => {
          let datosPulsechek:any={};
          console.log(element.completoCertificar);

          let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
          let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));

          if(fechaPortal){
            console.log("econtro 1");
          this.btnPortalConteos=true;
        }else{
          this.btnPortalConteos=false;
        }
          if(fechaActual){
           datosPulsechek={
             completoCertificar: element.completoCertificar,
             fechaLanzamiento: element.fechaLanzamiento,
             fechaCertificar: element.fechaCertificar,
             idPlantilla: element.idPlantilla,
             idCertiticar: element.idCertiticar,
             idSurvey: element.idSurvey,
             tokenConfig: element.tokenConfig,
             btnPortalConteos:this.btnPortalConteos,
             numPulse:element.numPulse,
             urlRT:element.urlRT,
             idProductoRT:element.idProducto,
             ipPublic:element.ipPublic,
             survey_subdomain:element.survey_subdomain,
           }

            console.log(datosPulsechek);

            if(element.fechaCertificar == fechaActual){
              fechaPulse.push(element);
              // fechaPulse.push(datosPulsechek);
            }
            else {
              this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
              fechaPulse=[];
              fechaActual=element.fechaCertificar;
              fechaPulse.push(element);
              // fechaPulse.push(datosPulsechek);
            }
          }
          else{
            fechaActual=element.fechaCertificar;
            fechaPulse.push(element);
            // fechaPulse.push(datosPulsechek);
          }
          fechaPulse.sort( (a,b) => {
            if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
          });
          if(pulseV3.length ==(i+1)){
            this.aniosPulsecheck.push({fecha: element.fechaCertificar, datos: fechaPulse});
          }
        });
        console.log(this.aniosPulsecheck);
      }

      focusAreaAños3(){
        this.aniosPulsecheck=[];
        let encuestaActiva:string;
        let modifUrlShort:boolean;
        let closeNotice:boolean;
        let selectNotice1:boolean;
        let selectNotice2:boolean;
        let moment = require('moment');
        let fechaActualC = moment().format('YYYY/MM/DD');
          let fechaActual:number;
          let fechaPulse:any[]=[];
          let pulseV3:any[]=[];
    this.productosContratadosInter.productosCertificar.forEach((element) => {
    if (element.idProducto==43) {
    pulseV3.push(element);
    }
    });

          pulseV3.sort( (a,b) => {
            if(a.fechaCertificar > b.fechaCertificar){
              return 1;
            } else{
              return -1;
            }
          });
          console.log(pulseV3);


          pulseV3.forEach((element,i) => {
            console.log('element',element);

            let datosPulsechek:any={};
            console.log(element.completoCertificar);

            let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
            let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));
            let modifUrlShort:boolean;
            let closeNotice:boolean;
            let selectNotice1:boolean;
            let selectNotice2:boolean;
            if(fechaPortal){
              console.log("econtro 1");
            this.btnPortalConteos=true;
          }else{
            this.btnPortalConteos=false;
          }
    console.log('surveyProductId');

          if (element.surveyProductId) {
            console.log('entro surveyProductId');

            closeNotice=element.surveyProductId.config.closeNotice;
            selectNotice1=element.surveyProductId.config.selectNotice1;
            selectNotice2=element.surveyProductId.config.selectNotice2;
            modifUrlShort=element.surveyProductId.config.customSurveyUrl;
          }else{
            console.log('entro producto viejo');
            modifUrlShort=true;
            closeNotice=true;
            selectNotice1=true;
            selectNotice2=true;
          }
            if(fechaActual){
             datosPulsechek={
               completoCertificar: element.completoCertificar,
               fechaLanzamiento: element.fechaLanzamiento,
               fechaCertificar: element.fechaCertificar,
               idPlantilla: element.idPlantilla,
               idCertificar: element.idCertificar,
               idSurvey: element.idSurvey,
               tokenConfig: element.tokenConfig,
               btnPortalConteos:this.btnPortalConteos,
               encuestaActiva:element.openSurvey,
               numPulse:element.numPulse,
               modifUrlShort:modifUrlShort,
               closeNotice:closeNotice,
               selectNotice1:selectNotice1,
               selectNotice2:selectNotice2,
               nameSurvey:element.nameSurvey,
               urlRT:element.urlRT,
               idProductoRT:element.idProducto,

             }

              console.log(datosPulsechek);

              if(element.fechaCertificar == fechaActual){
                // fechaPulse.push(element);
                fechaPulse.push(datosPulsechek);
              }
              else {
                this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
                fechaPulse=[];
                fechaActual=element.fechaCertificar;
                // fechaPulse.push(element);
                fechaPulse.push(datosPulsechek);
              }
            }
            else{
              datosPulsechek={
                completoCertificar: element.completoCertificar,
                fechaLanzamiento: element.fechaLanzamiento,
                fechaCertificar: element.fechaCertificar,
                idPlantilla: element.idPlantilla,
                idCertificar: element.idCertificar,
                idSurvey: element.idSurvey,
                tokenConfig: element.tokenConfig,
                btnPortalConteos:this.btnPortalConteos,
                numPulse:element.numPulse,
                encuestaActiva:element.openSurvey,
                modifUrlShort:modifUrlShort,
                closeNotice:closeNotice,
                selectNotice1:selectNotice1,
                selectNotice2:selectNotice2,
                nameSurvey:element.nameSurvey,
                urlRT:element.urlRT,

              }
              fechaActual=element.fechaCertificar;
              // fechaPulse.push(element);
              fechaPulse.push(datosPulsechek);
            }
            fechaPulse.sort( (a,b) => {
              if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
            });
            if(pulseV3.length ==(i+1)){
              this.aniosPulsecheck.push({fecha: element.fechaCertificar, datos: fechaPulse});
            }
          });
          // this.cargando=false;
          console.log(this.aniosPulsecheck);
        }

      copyMessage(urlRTExterno){
        this.openSuccessSnackBar(this.translateSrv.instant('WIZARD.LANDING_REQUERIMIENTOSV3.COPYA_MESSAGE'),'OK');
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        // selBox.value=val;
        selBox.value=urlRTExterno;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
      }
      openSuccessSnackBar(message: string, action: string) {
         this.snackBar.open(message, action, {
            duration: 5000,
            panelClass: ['background-success']
         });
      }

}
